import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { UserApi } from '../../api/userApi';
const UserSettingsIsland = () => {
    const [settingsData, setSettingsData] = useState(null);
    const [formData, setFormData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [toast, setToast] = useState(null);
    useEffect(() => {
        // Получаем данные из DOM
        const container = document.getElementById('user-settings-root');
        if (!container) {
            return;
        }
        const displayName = container.dataset.displayName || '';
        const language = container.dataset.language || 'en';
        const displayNameCustom = container.dataset.displayNameCustom || '';
        const maxDisplayNameLength = parseInt(container.dataset.maxDisplayNameLength || '50', 10);
        let availableLanguages = [];
        // Читаем доступные языки из глобального объекта, переданного сервером
        const globalLanguages = window.__userSettingsAvailableLanguages;
        if (globalLanguages && Array.isArray(globalLanguages)) {
            availableLanguages = [...globalLanguages];
        }
        // Если текущий язык пользователя не входит в доступные языки, добавляем его
        // Это гарантирует, что пользователь не "заблокируется" на неподдерживаемом языке
        const currentLanguageExists = availableLanguages.some(lang => lang.code === language);
        if (!currentLanguageExists && language && language !== 'en') {
            // Получаем отображаемое имя для текущего языка
            const languageDisplayNames = {
                'ru': 'Русский',
                'de': 'Deutsch',
                'fr': 'Français',
                'es': 'Español',
                'it': 'Italiano',
                'pt': 'Português',
                'ja': '日本語',
                'zh': '中文',
            };
            availableLanguages.push({
                code: language,
                displayName: languageDisplayNames[language] || language.toUpperCase()
            });
        }
        setSettingsData({
            displayName,
            language,
            displayNameCustom,
            maxDisplayNameLength,
            availableLanguages
        });
        setFormData({
            displayName,
            language
        });
    }, []);
    const showToast = (type, message) => {
        setToast({ type, message });
        setTimeout(() => setToast(null), 3000);
    };
    const handleDisplayNameChange = (e) => {
        const newName = e.target.value;
        if (newName.length > ((settingsData === null || settingsData === void 0 ? void 0 : settingsData.maxDisplayNameLength) || 50)) {
            showToast('error', 'Имя: от 1 до 50 символов.');
            return;
        }
        setFormData(prev => prev ? Object.assign(Object.assign({}, prev), { displayName: newName }) : prev);
    };
    const handleLanguageChange = (e) => {
        const newLanguage = e.target.value;
        setFormData(prev => prev ? Object.assign(Object.assign({}, prev), { language: newLanguage }) : prev);
    };
    const handleSave = async () => {
        if (!settingsData || !formData) {
            return;
        }
        const trimmedDisplayName = formData.displayName.trim();
        if (!trimmedDisplayName || trimmedDisplayName.length > settingsData.maxDisplayNameLength) {
            showToast('error', `Имя: от 1 до ${settingsData.maxDisplayNameLength} символов.`);
            return;
        }
        const displayNameChanged = trimmedDisplayName !== settingsData.displayName;
        const languageChanged = formData.language !== settingsData.language;
        if (!displayNameChanged && !languageChanged) {
            showToast('success', 'Изменений нет.');
            return;
        }
        try {
            setLoading(true);
            const userApi = new UserApi();
            if (displayNameChanged) {
                await userApi.updateDisplayName(trimmedDisplayName);
            }
            if (languageChanged) {
                await userApi.updateSettings(formData.language);
            }
            // Update both states with the new values
            setSettingsData(prev => (Object.assign(Object.assign({}, prev), { displayName: trimmedDisplayName, language: formData.language })));
            setFormData({
                displayName: trimmedDisplayName,
                language: formData.language
            });
            showToast('success', 'Настройки сохранены.');
        }
        catch (error) {
            showToast('error', 'Ошибка при сохранении настроек.');
            console.error('Save user settings error:', error);
        }
        finally {
            setLoading(false);
        }
    };
    if (!settingsData || !formData) {
        return null;
    }
    const { displayName, language, maxDisplayNameLength, availableLanguages } = settingsData;
    const hasChanges = formData.displayName.trim() !== displayName || formData.language !== language;
    return (_jsx("div", { className: "row justify-content-center", children: _jsxs("div", { className: "col-md-7 col-lg-6", children: [_jsx("h1", { className: "mb-4", children: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438" }), _jsx("div", { className: "card mb-3", children: _jsxs("div", { className: "card-body", children: [_jsx("label", { htmlFor: "displayName", className: "form-label", children: "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u043C\u043E\u0435 \u0438\u043C\u044F" }), _jsx("div", { className: "input-group", children: _jsx("input", { type: "text", className: "form-control", id: "displayName", value: formData.displayName, onChange: handleDisplayNameChange, maxLength: maxDisplayNameLength, disabled: loading, required: true }) }), _jsx("div", { className: "form-text", children: "\u041F\u043E\u0441\u043B\u0435 \u0440\u0443\u0447\u043D\u043E\u0439 \u0441\u043C\u0435\u043D\u044B \u0438\u043C\u044F \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435 \u043F\u0435\u0440\u0435\u0437\u0430\u043F\u0438\u0441\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u043E\u043C \u0432\u0445\u043E\u0434\u0430." })] }) }), _jsx("div", { className: "card", children: _jsxs("div", { className: "card-body", children: [_jsx("label", { htmlFor: "language", className: "form-label", children: "\u042F\u0437\u044B\u043A \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430" }), _jsx("div", { className: "input-group", children: _jsx("select", { className: "form-select", id: "language", value: formData.language, onChange: handleLanguageChange, disabled: loading, children: availableLanguages.map(lang => (_jsx("option", { value: lang.code, children: lang.displayName }, lang.code))) }) })] }) }), _jsx("div", { className: "d-flex justify-content-end mt-3", children: _jsx("button", { className: "btn btn-primary", type: "button", onClick: handleSave, disabled: loading || !hasChanges, children: loading ? 'Сохранение...' : 'Сохранить' }) }), toast && (_jsx("div", { className: `toast-container position-fixed bottom-0 end-0 p-3`, children: _jsx("div", { className: `toast align-items-center text-bg-${toast.type === 'success' ? 'success' : 'danger'} border-0`, role: "alert", "aria-live": "assertive", "aria-atomic": "true", children: _jsxs("div", { className: "d-flex", children: [_jsx("div", { className: "toast-body", children: toast.message }), _jsx("button", { type: "button", className: "btn-close btn-close-modal me-2 m-auto", "data-bs-dismiss": "toast", "aria-label": "Close" })] }) }) }))] }) }));
};
export default UserSettingsIsland;
